import { GroupedVehicleDataMap } from '@/new-transport/_models/transport.model';
import { DatePipe, KeyValuePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-transport-modal-email-dialog',
	standalone: true,
	imports: [NgClass, KeyValuePipe, DatePipe],
	template: `@for (element of data | keyvalue: originalOrder; track element.key; let isLast = $last) {
		<div
			[ngClass]="{
				'pb-3': !isLast,
			}"
		>
			<b>{{ element.key }}</b
			><br />
			@for (stop of element.value; track stop.city) {
				{{ stop.city }}, {{ stop.address }}, {{ stop.timeDeparture | date: 'dd.MM.yyyy' }}, godz.
				{{ stop.timeDeparture | date: 'HH:mm' }}, il os.
				<span matTooltip="Potwierdzone + Opcje">
					{{ stop.totalPassengers.confirmed }} + {{ stop.totalPassengers.optional }}
				</span>
				<br />
			}
		</div>
	} `,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportModalEmailDialogComponent {
	readonly data: GroupedVehicleDataMap = inject(MAT_DIALOG_DATA);

	originalOrder = (): number => 0;
}
